import { ButtonIcon, Table } from "mta-rkvr-styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { get, remove } from "../api/fetch";
import { ProceedingMessagesResponseBody } from "../api/HomePageResponseTypes";
import { ColumnHeader, ProceedingMessage } from "../types/homepage/ProceedingMessages";
import { Paginator } from "../types/util/TableFunctionalityTypes";
import { mapClassifiersValuesToLabels } from "../util/classifierManager";
import { toLocaleDate } from "../util/conversionUtils";
import { PROCEEDINGS } from "../util/paths";

const ProceedingMessages = () => {
  const { t } = useTranslation();
  const tBase = "homePageAuth.proceedingMessages.";

  const [messages, setMessages] = useState<ProceedingMessage[]>();
  const [refreshObservable, setRefreshObservable] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const refresh = () => {
    setRefreshObservable(!refreshObservable);
  };

  useEffect(() => {
    getMessages();
  }, [refreshObservable]);

  const getMessages = (pageSize?: number, elementOffset?: number) => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    get<ProceedingMessagesResponseBody>({
      endPoint: "proceedingsMessages",
      queryParams: [
        { name: "limit", value: pageSize ? pageSize : 10 },
        { name: "offset", value: elementOffset ? elementOffset : 0 },
      ],
    }).then(async ({ body }) => {
      const { resultsList: messages } = body;
      const labelsObject = await mapClassifiersValuesToLabels([
        {
          type: "menetlusType",
          values: messages.map((message) => message.menetluseLiik),
        },
        {
          type: "menetlusTypeSubtype",
          values: messages.map((message) => message.menetluseAlamliik),
        },
        {
          type: "menetlusStateTypes",
          values: messages.map((message) => message.seisund),
        },
        {
          type: "menetlusTeateTypes",
          values: messages.map((message) => message.teateLiik),
        },
      ]);

      setMessages(
        body.resultsList.map((message) => {
          return {
            ...message,
            menetluseLiik: {
              label: labelsObject.menetlusType!.shift()!,
              value: message.menetluseAlamliik,
            },
            menetluseAlamliik: {
              label: labelsObject.menetlusTypeSubtype!.shift()!,
              value: message.menetluseAlamliik,
            },
            seisund: {
              label: labelsObject.menetlusStateTypes!.shift()!,
              value: message.menetluseAlamliik,
            },
            teateLiik: {
              label: labelsObject.menetlusTeateTypes!.shift()!,
              value: message.menetluseAlamliik,
            },
            saadetud: toLocaleDate(message.saadetud),
            tahtaeg: toLocaleDate(message.tahtaeg),
            vastatud: toLocaleDate(message.vastatud),
          };
        }),
      );
      setPaginator({
        elementOffset: body.offset,
        numberOfElements: body.resultCount,
        pageSize: body.limit,
        totalElements: body.totalCount,
      });
      setLoading(false);
    });
  };
  const [paginator, setPaginator] = useState<Paginator>();

  const onPagination = (paginator: { pageSize: number; elementOffset: number }) => {
    getMessages(paginator.pageSize, paginator.elementOffset);
  };

  const markDone = (id: number) => {
    remove<never>({ endpoint: "accountMessages", pathParams: [id] }).then((res) => {
      res.ok && refresh();
    });
  };

  return (
    <>
      {messages && (
        <Table
          id={t(tBase + "title")}
          title={t(tBase + "title")}
          headers={Object.keys(ColumnHeader).map((header) => {
            return t(tBase + header);
          })}
          paginator={paginator}
          onPagination={onPagination}
          content={messages?.map((message) => {
            const {
              menetluseAlamliik,
              menetluseId,
              menetluseLiik,
              menetluseNumber,
              saadetud,
              saaja,
              saatja,
              seisund,
              tahtaeg,
              teateLiik,
              teateSisu,
              vastatud,
              vastus,
            } = message;
            return {
              menetluseNumber: <Link to={`${PROCEEDINGS}/${menetluseId}`}>{menetluseNumber}</Link>,
              menetluseLiik: menetluseLiik.label,
              menetluseAlamliik: menetluseAlamliik.label,
              seisund: seisund.label,
              teateLiik: teateLiik.label,
              saatja,
              saadetud,
              teateSisu,
              saaja,
              tahtaeg,
              vastus,
              vastatud,
            };
          })}
          translate={t}
          wrapBigColumns
          subTables={{
            contents: messages.map((message) => {
              return [{ teateSisu: message.vastus }];
            }),
            togglers: ["vastus"],
          }}
          rowIds={messages.map((message) => message.menetlusteateId)}
          editable
          customEditRowComponent={(obj: { rowId: number }) => (
            <ButtonIcon iconName={"icon-delete"} onClick={() => markDone(obj.rowId)} tooltip={t(tBase + "markDone")} />
          )}
          /* sortableColumns={sortableColumns}
					onSorting={onSorting} */
        />
      )}
    </>
  );
};

export default ProceedingMessages;
